// test59
(59 && 0);
